import { render } from "./DepartmentList.vue?vue&type=template&id=4b08c0bc"
import script from "./DepartmentList.vue?vue&type=script&lang=js"
export * from "./DepartmentList.vue?vue&type=script&lang=js"

import "./DepartmentList.vue?vue&type=style&index=0&id=4b08c0bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__